import { mainApiAxios as axios } from '@/plugins/axios'

export default {


    list(searchInput) {
        return axios.post('processes/search', searchInput)
    },

	createProcess(formData) {
        return axios.post('processes', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        })
    },

    createSurveyExecutionRequest(formData) {
        return axios.post('survey-execution-requests', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        })
    },

    getSurveyExecutionRequestByTask(taskId) {
        return axios.get(`survey-execution-requests/by-task/${taskId}`)
    },

    getSurveyExecutionRequestByProcess(processInstanceId) {
        return axios.get(`survey-execution-requests/by-process/${processInstanceId}`)
    },

    createStrategicSatisfactionRequest(formData) {
        return axios.post('strategic-satisfaction-requests', formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        })
    },

    getStrategicSatisfactionRequestByTask(taskId) {
        return axios.get(`strategic-satisfaction-requests/by-task/${taskId}`)
    },

    getStrategicSatisfactionRequestByProcess(processInstanceId) {
        return axios.get(`strategic-satisfaction-requests/by-process/${processInstanceId}`)
    },

    createOperationalIndicatorRequest(formData) {
        return axios.post('operational-indicator-requests', formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        })
    },

    getOperationalIndicatorRequestByTask(taskId) {
        return axios.get(`operational-indicator-requests/by-task/${taskId}`)
    },

    getOperationalIndicatorRequestByProcess(processInstanceId) {
        return axios.get(`operational-indicator-requests/by-process/${processInstanceId}`)
    },

    createAdditionalAnalysisRequest(formData) {
        return axios.post('additional-analysis-requests', formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        })
    },

    getAdditionalAnalysisRequestByTask(taskId) {
        return axios.get(`additional-analysis-requests/by-task/${taskId}`)
    },

    getAdditionalAnalysisRequestByProcess(processInstanceId) {
        return axios.get(`additional-analysis-requests/by-process/${processInstanceId}`)
    },

    createScientificConsultationRequest(formData) {
        return axios.post('scientific-consultation-requests', formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        })
    },

    getScientificConsultationRequestByTask(taskId) {
        return axios.get(`scientific-consultation-requests/by-task/${taskId}`)
    },

    getScientificConsultationRequestByProcess(processInstanceId) {
        return axios.get(`scientific-consultation-requests/by-process/${processInstanceId}`)
    },

    createFocusGroupsRequest(formData) {
        return axios.post('focus-groups-requests', formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        })
    },

    getFocusGroupsRequestByTask(taskId) {
        return axios.get(`focus-groups-requests/by-task/${taskId}`)
    },

    getFocusGroupsRequestByProcess(processInstanceId) {
        return axios.get(`focus-groups-requests/by-process/${processInstanceId}`)
    },

    createInquiryRequest(formData) {
        return axios.post('inquiry-requests', formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        })
    },

    getInquiryRequestByTask(taskId) {
        return axios.get(`inquiry-requests/by-task/${taskId}`)
    },

    getInquiryRequestByProcess(processInstanceId) {
        return axios.get(`inquiry-requests/by-process/${processInstanceId}`)
    },

    getProcessComments(processInstanceId) {
        return axios.get(`notes/by-process/${processInstanceId}`)
    },

    downloadSurveyExecutionAttachment(path) {
        return axios.get('survey-execution-requests/attachment', { params: { path }, responseType: 'blob' })
    },

    listActivities(processInstanceId) {
        return axios.get(`processes/${processInstanceId}/activities`)
    },

    getProcess(processInstanceId) {
        return axios.get(`processes/${processInstanceId}`)
    },

    listLetters(processInstanceId) {
        return axios.get(`processes/${processInstanceId}/letters`)
    },

    listCommentsByProcessId(processInstanceId) {
        return axios.get(`processes/${processInstanceId}/comments`)
    },

    listProcesses() {
        return axios.get('processes/apps')
    },

    listInitiationData(processInstanceId) {
        return axios.get(`processes/${processInstanceId}/initiation`)
    },

    listCommentsReport(search) {
        return axios.post('processes/comments-report', search)
    },

    getProcessStatusReport() {
        return axios.get('processes/reports/process-status-report')
    },

    getFinancialProcessReport() {
        return axios.get('processes/reports/financial-process-report')
    },

    listAuditItems(processInstanceId) {
        return axios.get(`processes/${processInstanceId}/auditItems`)
    },
}